<div class="iterate-collection__control-panel--add">
  <button cp-button theme="blue-alt" variant="primary" size="regular" (click)="showUnsupportedGenericModal()">
    {{ questionItem.qText }}
  </button>
</div>
